import React from 'react';
import { Typography } from '@mui/material';
import { IPanelTitle } from './interfaces';

export const PanelTitle: React.FC<IPanelTitle> = ({ title }): JSX.Element => {
  return (
    <Typography
      component="h1"
      variant="h4"
      sx={{
        width: '100%',
        fontSize: 'clamp(2rem, 10vw, 2.15rem)',
      }}
    >
      {title}
    </Typography>
  );
};
